/* tslint:disable */
/* eslint-disable */
/**
 * RSS API
 * Renewed Shopping Station API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const BannerTypeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type BannerTypeEnum = typeof BannerTypeEnum[keyof typeof BannerTypeEnum];


/**
 * BrowsingHistorySerializer return BrowsingHistory item object.
 * @export
 * @interface BrowsingHistory
 */
export interface BrowsingHistory {
    /**
     * 
     * @type {number}
     * @memberof BrowsingHistory
     */
    'id': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof BrowsingHistory
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof BrowsingHistory
     */
    'sku': number;
}
/**
 * BrowsingHistoryGetSerializer return list of BrowsingHistory item including sku data.
 * @export
 * @interface BrowsingHistoryGet
 */
export interface BrowsingHistoryGet {
    /**
     * 
     * @type {number}
     * @memberof BrowsingHistoryGet
     */
    'id': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof BrowsingHistoryGet
     */
    'user': number;
    /**
     * 
     * @type {SKU}
     * @memberof BrowsingHistoryGet
     */
    'sku': SKU;
}
/**
 * BrowsingHistorySerializer return BrowsingHistory item object.
 * @export
 * @interface BrowsingHistoryRequest
 */
export interface BrowsingHistoryRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof BrowsingHistoryRequest
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof BrowsingHistoryRequest
     */
    'sku': number;
}
/**
 * 
 * @export
 * @interface DisplayCategory
 */
export interface DisplayCategory {
    /**
     * 
     * @type {number}
     * @memberof DisplayCategory
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DisplayCategory
     */
    'name': string;
    /**
     * 
     * @type {LevelEnum}
     * @memberof DisplayCategory
     */
    'level'?: LevelEnum;
    /**
     * category icon in svg format. The response should be a full URL
     * @type {string}
     * @memberof DisplayCategory
     */
    'icon'?: string | null;
    /**
     * 
     * @type {PremiumCategoryExtra}
     * @memberof DisplayCategory
     */
    'main_category': PremiumCategoryExtra;
    /**
     * 
     * @type {PremiumCategoryExtra}
     * @memberof DisplayCategory
     */
    'sub_categories': PremiumCategoryExtra;
}
/**
 * FavoriteSerializer return favorite item object.
 * @export
 * @interface Favorite
 */
export interface Favorite {
    /**
     * 
     * @type {number}
     * @memberof Favorite
     */
    'id': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof Favorite
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof Favorite
     */
    'sku': number;
}
/**
 * FavoriteGetSerializer return list of favorite item including sku data.
 * @export
 * @interface FavoriteGet
 */
export interface FavoriteGet {
    /**
     * 
     * @type {number}
     * @memberof FavoriteGet
     */
    'id': number;
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof FavoriteGet
     */
    'user': number;
    /**
     * 
     * @type {SKU}
     * @memberof FavoriteGet
     */
    'sku': SKU;
}
/**
 * FavoriteSerializer return favorite item object.
 * @export
 * @interface FavoriteRequest
 */
export interface FavoriteRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof FavoriteRequest
     */
    'user': number;
    /**
     * 
     * @type {number}
     * @memberof FavoriteRequest
     */
    'sku': number;
}
/**
 * FeatureBannerSerializer is used for feature banner retrieve API.
 * @export
 * @interface FeatureBanner
 */
export interface FeatureBanner {
    /**
     * 
     * @type {number}
     * @memberof FeatureBanner
     */
    'id': number;
    /**
     * Name of banner
     * @type {string}
     * @memberof FeatureBanner
     */
    'name': string;
    /**
     * 
     * @type {BannerTypeEnum}
     * @memberof FeatureBanner
     */
    'banner_type': BannerTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof FeatureBanner
     */
    'categories'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof FeatureBanner
     */
    'premiums'?: Array<number>;
    /**
     * Redirect URL of banner
     * @type {string}
     * @memberof FeatureBanner
     */
    'url'?: string | null;
    /**
     * Organization ID from the Authentication system
     * @type {number}
     * @memberof FeatureBanner
     */
    'organization'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof FeatureBanner
     */
    'image': string;
    /**
     * Display order of banner
     * @type {number}
     * @memberof FeatureBanner
     */
    'display_order': number;
    /**
     * Publication start date of banner
     * @type {string}
     * @memberof FeatureBanner
     */
    'publication_start_date'?: string;
    /**
     * Publication end date of banner
     * @type {string}
     * @memberof FeatureBanner
     */
    'publication_end_date'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LevelEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2
} as const;

export type LevelEnum = typeof LevelEnum[keyof typeof LevelEnum];


/**
 * 
 * @export
 * @interface OptionType
 */
export interface OptionType {
    /**
     * 
     * @type {number}
     * @memberof OptionType
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof OptionType
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OptionTypeExtra
 */
export interface OptionTypeExtra {
    /**
     * 
     * @type {number}
     * @memberof OptionTypeExtra
     */
    'id': number;
    /**
     * Name of extra option type
     * @type {string}
     * @memberof OptionTypeExtra
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof OptionTypeExtra
     */
    'sku': number;
    /**
     * Display order of extra option type
     * @type {number}
     * @memberof OptionTypeExtra
     */
    'display_order': number;
    /**
     * Minimum length of extra option type value
     * @type {number}
     * @memberof OptionTypeExtra
     */
    'min_length'?: number;
    /**
     * Maximum length of extra option type value
     * @type {number}
     * @memberof OptionTypeExtra
     */
    'max_length'?: number;
    /**
     * Regular expression of extra option type value
     * @type {string}
     * @memberof OptionTypeExtra
     */
    'regex'?: string | null;
}
/**
 * 
 * @export
 * @interface PaginatedBrowsingHistoryGetList
 */
export interface PaginatedBrowsingHistoryGetList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedBrowsingHistoryGetList
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedBrowsingHistoryGetList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedBrowsingHistoryGetList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<BrowsingHistoryGet>}
     * @memberof PaginatedBrowsingHistoryGetList
     */
    'results'?: Array<BrowsingHistoryGet>;
}
/**
 * 
 * @export
 * @interface PaginatedFavoriteGetList
 */
export interface PaginatedFavoriteGetList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedFavoriteGetList
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedFavoriteGetList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedFavoriteGetList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<FavoriteGet>}
     * @memberof PaginatedFavoriteGetList
     */
    'results'?: Array<FavoriteGet>;
}
/**
 * 
 * @export
 * @interface PaginatedSKUList
 */
export interface PaginatedSKUList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedSKUList
     */
    'count'?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSKUList
     */
    'next'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedSKUList
     */
    'previous'?: string | null;
    /**
     * 
     * @type {Array<SKU>}
     * @memberof PaginatedSKUList
     */
    'results'?: Array<SKU>;
}
/**
 * BrowsingHistorySerializer return BrowsingHistory item object.
 * @export
 * @interface PatchedBrowsingHistoryRequest
 */
export interface PatchedBrowsingHistoryRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedBrowsingHistoryRequest
     */
    'user'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedBrowsingHistoryRequest
     */
    'sku'?: number;
}
/**
 * FavoriteSerializer return favorite item object.
 * @export
 * @interface PatchedFavoriteRequest
 */
export interface PatchedFavoriteRequest {
    /**
     * User ID from the Authentication system
     * @type {number}
     * @memberof PatchedFavoriteRequest
     */
    'user'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedFavoriteRequest
     */
    'sku'?: number;
}
/**
 * 
 * @export
 * @interface PatchedSKURedeemChildRequest
 */
export interface PatchedSKURedeemChildRequest {
    /**
     * 
     * @type {number}
     * @memberof PatchedSKURedeemChildRequest
     */
    'sku_id'?: number;
    /**
     * 
     * @type {number}
     * @memberof PatchedSKURedeemChildRequest
     */
    'quantity'?: number;
}
/**
 * PremiumSerializer is used in SKUSerializer for sku list API.
 * @export
 * @interface Premium
 */
export interface Premium {
    /**
     * 
     * @type {number}
     * @memberof Premium
     */
    'id': number;
    /**
     * menu no in ICDB
     * @type {string}
     * @memberof Premium
     */
    'menu_no': string;
    /**
     * 
     * @type {string}
     * @memberof Premium
     */
    'name': string;
    /**
     * kana name in japanese
     * @type {string}
     * @memberof Premium
     */
    'name_kana': string;
    /**
     * main comment of premium
     * @type {string}
     * @memberof Premium
     */
    'catch': string;
    /**
     * detail main comment of premium
     * @type {string}
     * @memberof Premium
     */
    'text': string;
    /**
     * detail sub comment of premium
     * @type {string}
     * @memberof Premium
     */
    'content': string;
    /**
     * sub comment of premium
     * @type {string}
     * @memberof Premium
     */
    'note': string;
    /**
     * 
     * @type {string}
     * @memberof Premium
     */
    'is_new': string;
    /**
     * 
     * @type {boolean}
     * @memberof Premium
     */
    'is_featured'?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof Premium
     */
    'categories': Array<number>;
    /**
     * 
     * @type {Array<OptionType>}
     * @memberof Premium
     */
    'option_types': Array<OptionType>;
    /**
     * 
     * @type {RedemptionTypeEnum}
     * @memberof Premium
     */
    'redemption_type': RedemptionTypeEnum;
    /**
     * Rate of tax
     * @type {TaxRateEnum}
     * @memberof Premium
     */
    'tax_rate'?: TaxRateEnum;
    /**
     * 
     * @type {PremiumRedemptionMailMessage}
     * @memberof Premium
     */
    'redemption_mail_message': PremiumRedemptionMailMessage | null;
    /**
     * 
     * @type {Array<PremiumImage>}
     * @memberof Premium
     */
    'premiumimage_set': Array<PremiumImage>;
    /**
     * 
     * @type {string}
     * @memberof Premium
     */
    'final_tax_rate': string;
    /**
     * 
     * @type {boolean}
     * @memberof Premium
     */
    'is_age_alert': boolean;
}
/**
 * 
 * @export
 * @interface PremiumCategory
 */
export interface PremiumCategory {
    /**
     * 
     * @type {number}
     * @memberof PremiumCategory
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PremiumCategory
     */
    'name': string;
    /**
     * 
     * @type {LevelEnum}
     * @memberof PremiumCategory
     */
    'level'?: LevelEnum;
    /**
     * category icon in svg format. The response should be a full URL
     * @type {string}
     * @memberof PremiumCategory
     */
    'icon'?: string | null;
    /**
     * 
     * @type {PremiumCategoryExtra}
     * @memberof PremiumCategory
     */
    'main_category': PremiumCategoryExtra;
    /**
     * 
     * @type {PremiumCategoryExtra}
     * @memberof PremiumCategory
     */
    'sub_categories': PremiumCategoryExtra;
}
/**
 * 
 * @export
 * @interface PremiumCategoryExtra
 */
export interface PremiumCategoryExtra {
    /**
     * 
     * @type {number}
     * @memberof PremiumCategoryExtra
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PremiumCategoryExtra
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PremiumCategoryExtra
     */
    'level': number;
    /**
     * 
     * @type {string}
     * @memberof PremiumCategoryExtra
     */
    'icon': string;
}
/**
 * 
 * @export
 * @interface PremiumImage
 */
export interface PremiumImage {
    /**
     * 
     * @type {number}
     * @memberof PremiumImage
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PremiumImage
     */
    'image_url': string;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumImage
     */
    'is_primary'?: boolean;
}
/**
 * 
 * @export
 * @interface PremiumOptions
 */
export interface PremiumOptions {
    /**
     * 
     * @type {number}
     * @memberof PremiumOptions
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof PremiumOptions
     */
    'option_type': number;
    /**
     * 
     * @type {string}
     * @memberof PremiumOptions
     */
    'option_type_name': string;
    /**
     * 
     * @type {string}
     * @memberof PremiumOptions
     */
    'value': string;
}
/**
 * PremiumRankingSerializer return premium for ranking.
 * @export
 * @interface PremiumRanking
 */
export interface PremiumRanking {
    /**
     * 
     * @type {number}
     * @memberof PremiumRanking
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PremiumRanking
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PremiumRanking
     */
    'is_new': string;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumRanking
     */
    'is_featured'?: boolean;
    /**
     * 
     * @type {Array<PremiumImage>}
     * @memberof PremiumRanking
     */
    'premiumimage_set': Array<PremiumImage>;
}
/**
 * 
 * @export
 * @interface PremiumRedemptionMailMessage
 */
export interface PremiumRedemptionMailMessage {
    /**
     * 
     * @type {number}
     * @memberof PremiumRedemptionMailMessage
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PremiumRedemptionMailMessage
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PremiumRedemptionMailMessage
     */
    'text'?: string | null;
}
/**
 * PremiumRetrieveSerializer return premium, which include all SKU associated with that premium with help of SKURetrieveSerializer
 * @export
 * @interface PremiumRetrieve
 */
export interface PremiumRetrieve {
    /**
     * 
     * @type {number}
     * @memberof PremiumRetrieve
     */
    'id': number;
    /**
     * menu no in ICDB
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'menu_no': string;
    /**
     * 
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'name': string;
    /**
     * kana name in japanese
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'name_kana': string;
    /**
     * main comment of premium
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'catch': string;
    /**
     * detail main comment of premium
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'text': string;
    /**
     * detail sub comment of premium
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'content': string;
    /**
     * sub comment of premium
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'note': string;
    /**
     * 
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'is_new': string;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumRetrieve
     */
    'is_featured'?: boolean;
    /**
     * 
     * @type {Array<PremiumCategory>}
     * @memberof PremiumRetrieve
     */
    'categories': Array<PremiumCategory>;
    /**
     * 
     * @type {Array<OptionType>}
     * @memberof PremiumRetrieve
     */
    'option_types': Array<OptionType>;
    /**
     * 
     * @type {RedemptionTypeEnum}
     * @memberof PremiumRetrieve
     */
    'redemption_type': RedemptionTypeEnum;
    /**
     * Rate of tax
     * @type {TaxRateEnum}
     * @memberof PremiumRetrieve
     */
    'tax_rate'?: TaxRateEnum;
    /**
     * 
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'sale_start_date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'sale_end_date'?: string;
    /**
     * 
     * @type {PremiumRedemptionMailMessage}
     * @memberof PremiumRetrieve
     */
    'redemption_mail_message': PremiumRedemptionMailMessage | null;
    /**
     * 
     * @type {Array<PremiumImage>}
     * @memberof PremiumRetrieve
     */
    'premiumimage_set': Array<PremiumImage>;
    /**
     * 
     * @type {Array<SKURetrieve>}
     * @memberof PremiumRetrieve
     */
    'sku_set': Array<SKURetrieve>;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumRetrieve
     */
    'is_age_alert': boolean;
    /**
     * 
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'final_tax_rate': string;
    /**
     * 
     * @type {string}
     * @memberof PremiumRetrieve
     */
    'client_list': string;
    /**
     * 
     * @type {boolean}
     * @memberof PremiumRetrieve
     */
    'is_hidden_item': boolean;
}
/**
 * 
 * @export
 * @interface RankingByCategoryChild
 */
export interface RankingByCategoryChild {
    /**
     * 
     * @type {number}
     * @memberof RankingByCategoryChild
     */
    'category_id': number;
    /**
     * 
     * @type {string}
     * @memberof RankingByCategoryChild
     */
    'category_name': string;
    /**
     * 
     * @type {Array<PremiumRanking>}
     * @memberof RankingByCategoryChild
     */
    'premium_set': Array<PremiumRanking>;
}
/**
 * 
 * @export
 * @interface RankingByPointsChild
 */
export interface RankingByPointsChild {
    /**
     * 
     * @type {number}
     * @memberof RankingByPointsChild
     */
    'lower_limit': number;
    /**
     * 
     * @type {number}
     * @memberof RankingByPointsChild
     */
    'upper_limit': number;
    /**
     * 
     * @type {Array<PremiumRanking>}
     * @memberof RankingByPointsChild
     */
    'premium_set': Array<PremiumRanking>;
}
/**
 * 
 * @export
 * @interface RedemptionMailMessage
 */
export interface RedemptionMailMessage {
    /**
     * 
     * @type {number}
     * @memberof RedemptionMailMessage
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof RedemptionMailMessage
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RedemptionMailMessage
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const RedemptionTypeEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;

export type RedemptionTypeEnum = typeof RedemptionTypeEnum[keyof typeof RedemptionTypeEnum];


/**
 * SKUSerializer return sku, which include premium with help of PremiumSerializer.
 * @export
 * @interface SKU
 */
export interface SKU {
    /**
     * 
     * @type {number}
     * @memberof SKU
     */
    'id': number;
    /**
     * product class id in ICDB
     * @type {number}
     * @memberof SKU
     */
    'icdb_product_class_id': number;
    /**
     * 
     * @type {Premium}
     * @memberof SKU
     */
    'premium': Premium;
    /**
     * 
     * @type {Array<PremiumOptions>}
     * @memberof SKU
     */
    'options': Array<PremiumOptions>;
    /**
     * 
     * @type {Supplier}
     * @memberof SKU
     */
    'supplier': Supplier;
    /**
     * 
     * @type {number}
     * @memberof SKU
     */
    'point_required': number;
    /**
     * False means unlimited stock
     * @type {boolean}
     * @memberof SKU
     */
    'is_quantity_control'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SKU
     */
    'quantity': number;
    /**
     * japanese article number
     * @type {string}
     * @memberof SKU
     */
    'jan_code'?: string | null;
    /**
     * price excluding tax
     * @type {number}
     * @memberof SKU
     */
    'price': number;
    /**
     * member price excluding tax
     * @type {number}
     * @memberof SKU
     */
    'member_price': number;
}
/**
 * SKURetrieveSerializer is used in PremiumRetrieveSerializer for premium retrieve API.
 * @export
 * @interface SKURetrieve
 */
export interface SKURetrieve {
    /**
     * 
     * @type {number}
     * @memberof SKURetrieve
     */
    'id': number;
    /**
     * product class id in ICDB
     * @type {number}
     * @memberof SKURetrieve
     */
    'icdb_product_class_id': number;
    /**
     * 
     * @type {Array<PremiumOptions>}
     * @memberof SKURetrieve
     */
    'options': Array<PremiumOptions>;
    /**
     * 
     * @type {Supplier}
     * @memberof SKURetrieve
     */
    'supplier': Supplier;
    /**
     * 
     * @type {number}
     * @memberof SKURetrieve
     */
    'point_required': number;
    /**
     * False means unlimited stock
     * @type {boolean}
     * @memberof SKURetrieve
     */
    'is_quantity_control'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SKURetrieve
     */
    'quantity': number;
    /**
     * japanese article number
     * @type {string}
     * @memberof SKURetrieve
     */
    'jan_code'?: string | null;
    /**
     * price excluding tax
     * @type {number}
     * @memberof SKURetrieve
     */
    'price': number;
    /**
     * member price excluding tax
     * @type {number}
     * @memberof SKURetrieve
     */
    'member_price': number;
    /**
     * 
     * @type {Array<OptionTypeExtra>}
     * @memberof SKURetrieve
     */
    'optiontypeextra_set': Array<OptionTypeExtra>;
    /**
     * 
     * @type {number}
     * @memberof SKURetrieve
     */
    'favorite_id': number;
}
/**
 * 
 * @export
 * @interface Supplier
 */
export interface Supplier {
    /**
     * 
     * @type {number}
     * @memberof Supplier
     */
    'id': number;
    /**
     * 
     * @type {boolean}
     * @memberof Supplier
     */
    'credit_card_support'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TaxRateEnum = {
    NUMBER_0_DOT_1: 0.1,
    NUMBER_0_DOT_08: 0.08
} as const;

export type TaxRateEnum = typeof TaxRateEnum[keyof typeof TaxRateEnum];



/**
 * AllSkuApi - axios parameter creator
 * @export
 */
export const AllSkuApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API that return sku details based on id. This api is not excluding sku based on NDR or sale date. So it is useful for Api Client of RIC transaction history.
         * @param {number} id A unique integer value identifying this sku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSkuRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('allSkuRetrieve', 'id', id)
            const localVarPath = `/api/all_sku/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AllSkuApi - functional programming interface
 * @export
 */
export const AllSkuApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AllSkuApiAxiosParamCreator(configuration)
    return {
        /**
         * API that return sku details based on id. This api is not excluding sku based on NDR or sale date. So it is useful for Api Client of RIC transaction history.
         * @param {number} id A unique integer value identifying this sku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allSkuRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SKU>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allSkuRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AllSkuApi - factory interface
 * @export
 */
export const AllSkuApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AllSkuApiFp(configuration)
    return {
        /**
         * API that return sku details based on id. This api is not excluding sku based on NDR or sale date. So it is useful for Api Client of RIC transaction history.
         * @param {number} id A unique integer value identifying this sku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allSkuRetrieve(id: number, options?: any): AxiosPromise<SKU> {
            return localVarFp.allSkuRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AllSkuApi - object-oriented interface
 * @export
 * @class AllSkuApi
 * @extends {BaseAPI}
 */
export class AllSkuApi extends BaseAPI {
    /**
     * API that return sku details based on id. This api is not excluding sku based on NDR or sale date. So it is useful for Api Client of RIC transaction history.
     * @param {number} id A unique integer value identifying this sku.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AllSkuApi
     */
    public allSkuRetrieve(id: number, options?: AxiosRequestConfig) {
        return AllSkuApiFp(this.configuration).allSkuRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BrowsingHistoryApi - axios parameter creator
 * @export
 */
export const BrowsingHistoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {BrowsingHistoryRequest} browsingHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryCreate: async (browsingHistoryRequest: BrowsingHistoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'browsingHistoryRequest' is not null or undefined
            assertParamExists('browsingHistoryCreate', 'browsingHistoryRequest', browsingHistoryRequest)
            const localVarPath = `/api/browsing_history/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(browsingHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryDestroy: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('browsingHistoryDestroy', 'id', id)
            const localVarPath = `/api/browsing_history/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryList: async (page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/browsing_history/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {PatchedBrowsingHistoryRequest} [patchedBrowsingHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryPartialUpdate: async (id: number, patchedBrowsingHistoryRequest?: PatchedBrowsingHistoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('browsingHistoryPartialUpdate', 'id', id)
            const localVarPath = `/api/browsing_history/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedBrowsingHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('browsingHistoryRetrieve', 'id', id)
            const localVarPath = `/api/browsing_history/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {BrowsingHistoryRequest} browsingHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryUpdate: async (id: number, browsingHistoryRequest: BrowsingHistoryRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('browsingHistoryUpdate', 'id', id)
            // verify required parameter 'browsingHistoryRequest' is not null or undefined
            assertParamExists('browsingHistoryUpdate', 'browsingHistoryRequest', browsingHistoryRequest)
            const localVarPath = `/api/browsing_history/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(browsingHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrowsingHistoryApi - functional programming interface
 * @export
 */
export const BrowsingHistoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrowsingHistoryApiAxiosParamCreator(configuration)
    return {
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {BrowsingHistoryRequest} browsingHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async browsingHistoryCreate(browsingHistoryRequest: BrowsingHistoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrowsingHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.browsingHistoryCreate(browsingHistoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async browsingHistoryDestroy(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.browsingHistoryDestroy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async browsingHistoryList(page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBrowsingHistoryGetList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.browsingHistoryList(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {PatchedBrowsingHistoryRequest} [patchedBrowsingHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async browsingHistoryPartialUpdate(id: number, patchedBrowsingHistoryRequest?: PatchedBrowsingHistoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrowsingHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.browsingHistoryPartialUpdate(id, patchedBrowsingHistoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async browsingHistoryRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrowsingHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.browsingHistoryRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {BrowsingHistoryRequest} browsingHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async browsingHistoryUpdate(id: number, browsingHistoryRequest: BrowsingHistoryRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrowsingHistory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.browsingHistoryUpdate(id, browsingHistoryRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BrowsingHistoryApi - factory interface
 * @export
 */
export const BrowsingHistoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrowsingHistoryApiFp(configuration)
    return {
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {BrowsingHistoryRequest} browsingHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryCreate(browsingHistoryRequest: BrowsingHistoryRequest, options?: any): AxiosPromise<BrowsingHistory> {
            return localVarFp.browsingHistoryCreate(browsingHistoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryDestroy(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.browsingHistoryDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryList(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedBrowsingHistoryGetList> {
            return localVarFp.browsingHistoryList(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {PatchedBrowsingHistoryRequest} [patchedBrowsingHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryPartialUpdate(id: number, patchedBrowsingHistoryRequest?: PatchedBrowsingHistoryRequest, options?: any): AxiosPromise<BrowsingHistory> {
            return localVarFp.browsingHistoryPartialUpdate(id, patchedBrowsingHistoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryRetrieve(id: number, options?: any): AxiosPromise<BrowsingHistory> {
            return localVarFp.browsingHistoryRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to manage BrowsingHistory item.
         * @param {number} id A unique integer value identifying this browsing history.
         * @param {BrowsingHistoryRequest} browsingHistoryRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        browsingHistoryUpdate(id: number, browsingHistoryRequest: BrowsingHistoryRequest, options?: any): AxiosPromise<BrowsingHistory> {
            return localVarFp.browsingHistoryUpdate(id, browsingHistoryRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrowsingHistoryApi - object-oriented interface
 * @export
 * @class BrowsingHistoryApi
 * @extends {BaseAPI}
 */
export class BrowsingHistoryApi extends BaseAPI {
    /**
     * API ednpoint that allows user to manage BrowsingHistory item.
     * @param {BrowsingHistoryRequest} browsingHistoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrowsingHistoryApi
     */
    public browsingHistoryCreate(browsingHistoryRequest: BrowsingHistoryRequest, options?: AxiosRequestConfig) {
        return BrowsingHistoryApiFp(this.configuration).browsingHistoryCreate(browsingHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to manage BrowsingHistory item.
     * @param {number} id A unique integer value identifying this browsing history.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrowsingHistoryApi
     */
    public browsingHistoryDestroy(id: number, options?: AxiosRequestConfig) {
        return BrowsingHistoryApiFp(this.configuration).browsingHistoryDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to manage BrowsingHistory item.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrowsingHistoryApi
     */
    public browsingHistoryList(page?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return BrowsingHistoryApiFp(this.configuration).browsingHistoryList(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to manage BrowsingHistory item.
     * @param {number} id A unique integer value identifying this browsing history.
     * @param {PatchedBrowsingHistoryRequest} [patchedBrowsingHistoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrowsingHistoryApi
     */
    public browsingHistoryPartialUpdate(id: number, patchedBrowsingHistoryRequest?: PatchedBrowsingHistoryRequest, options?: AxiosRequestConfig) {
        return BrowsingHistoryApiFp(this.configuration).browsingHistoryPartialUpdate(id, patchedBrowsingHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to manage BrowsingHistory item.
     * @param {number} id A unique integer value identifying this browsing history.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrowsingHistoryApi
     */
    public browsingHistoryRetrieve(id: number, options?: AxiosRequestConfig) {
        return BrowsingHistoryApiFp(this.configuration).browsingHistoryRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to manage BrowsingHistory item.
     * @param {number} id A unique integer value identifying this browsing history.
     * @param {BrowsingHistoryRequest} browsingHistoryRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrowsingHistoryApi
     */
    public browsingHistoryUpdate(id: number, browsingHistoryRequest: BrowsingHistoryRequest, options?: AxiosRequestConfig) {
        return BrowsingHistoryApiFp(this.configuration).browsingHistoryUpdate(id, browsingHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FavoriteApi - axios parameter creator
 * @export
 */
export const FavoriteApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {FavoriteRequest} favoriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteCreate: async (favoriteRequest: FavoriteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'favoriteRequest' is not null or undefined
            assertParamExists('favoriteCreate', 'favoriteRequest', favoriteRequest)
            const localVarPath = `/api/favorite/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(favoriteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteDestroy: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('favoriteDestroy', 'id', id)
            const localVarPath = `/api/favorite/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteList: async (page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/favorite/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {PatchedFavoriteRequest} [patchedFavoriteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritePartialUpdate: async (id: number, patchedFavoriteRequest?: PatchedFavoriteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('favoritePartialUpdate', 'id', id)
            const localVarPath = `/api/favorite/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedFavoriteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('favoriteRetrieve', 'id', id)
            const localVarPath = `/api/favorite/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {FavoriteRequest} favoriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteUpdate: async (id: number, favoriteRequest: FavoriteRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('favoriteUpdate', 'id', id)
            // verify required parameter 'favoriteRequest' is not null or undefined
            assertParamExists('favoriteUpdate', 'favoriteRequest', favoriteRequest)
            const localVarPath = `/api/favorite/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(favoriteRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FavoriteApi - functional programming interface
 * @export
 */
export const FavoriteApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FavoriteApiAxiosParamCreator(configuration)
    return {
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {FavoriteRequest} favoriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteCreate(favoriteRequest: FavoriteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteCreate(favoriteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteDestroy(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteDestroy(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteList(page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedFavoriteGetList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteList(page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {PatchedFavoriteRequest} [patchedFavoriteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoritePartialUpdate(id: number, patchedFavoriteRequest?: PatchedFavoriteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoritePartialUpdate(id, patchedFavoriteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {FavoriteRequest} favoriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoriteUpdate(id: number, favoriteRequest: FavoriteRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Favorite>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoriteUpdate(id, favoriteRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FavoriteApi - factory interface
 * @export
 */
export const FavoriteApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FavoriteApiFp(configuration)
    return {
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {FavoriteRequest} favoriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteCreate(favoriteRequest: FavoriteRequest, options?: any): AxiosPromise<Favorite> {
            return localVarFp.favoriteCreate(favoriteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteDestroy(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.favoriteDestroy(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteList(page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedFavoriteGetList> {
            return localVarFp.favoriteList(page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {PatchedFavoriteRequest} [patchedFavoriteRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritePartialUpdate(id: number, patchedFavoriteRequest?: PatchedFavoriteRequest, options?: any): AxiosPromise<Favorite> {
            return localVarFp.favoritePartialUpdate(id, patchedFavoriteRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteRetrieve(id: number, options?: any): AxiosPromise<Favorite> {
            return localVarFp.favoriteRetrieve(id, options).then((request) => request(axios, basePath));
        },
        /**
         * API ednpoint that allows user to manage Favorite item.
         * @param {number} id A unique integer value identifying this favorite.
         * @param {FavoriteRequest} favoriteRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoriteUpdate(id: number, favoriteRequest: FavoriteRequest, options?: any): AxiosPromise<Favorite> {
            return localVarFp.favoriteUpdate(id, favoriteRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FavoriteApi - object-oriented interface
 * @export
 * @class FavoriteApi
 * @extends {BaseAPI}
 */
export class FavoriteApi extends BaseAPI {
    /**
     * API ednpoint that allows user to manage Favorite item.
     * @param {FavoriteRequest} favoriteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    public favoriteCreate(favoriteRequest: FavoriteRequest, options?: AxiosRequestConfig) {
        return FavoriteApiFp(this.configuration).favoriteCreate(favoriteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to manage Favorite item.
     * @param {number} id A unique integer value identifying this favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    public favoriteDestroy(id: number, options?: AxiosRequestConfig) {
        return FavoriteApiFp(this.configuration).favoriteDestroy(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to manage Favorite item.
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    public favoriteList(page?: number, pageSize?: number, options?: AxiosRequestConfig) {
        return FavoriteApiFp(this.configuration).favoriteList(page, pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to manage Favorite item.
     * @param {number} id A unique integer value identifying this favorite.
     * @param {PatchedFavoriteRequest} [patchedFavoriteRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    public favoritePartialUpdate(id: number, patchedFavoriteRequest?: PatchedFavoriteRequest, options?: AxiosRequestConfig) {
        return FavoriteApiFp(this.configuration).favoritePartialUpdate(id, patchedFavoriteRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to manage Favorite item.
     * @param {number} id A unique integer value identifying this favorite.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    public favoriteRetrieve(id: number, options?: AxiosRequestConfig) {
        return FavoriteApiFp(this.configuration).favoriteRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API ednpoint that allows user to manage Favorite item.
     * @param {number} id A unique integer value identifying this favorite.
     * @param {FavoriteRequest} favoriteRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FavoriteApi
     */
    public favoriteUpdate(id: number, favoriteRequest: FavoriteRequest, options?: AxiosRequestConfig) {
        return FavoriteApiFp(this.configuration).favoriteUpdate(id, favoriteRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FeatureBannerApi - axios parameter creator
 * @export
 */
export const FeatureBannerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to give feature banner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureBannerRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/feature_banner/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FeatureBannerApi - functional programming interface
 * @export
 */
export const FeatureBannerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FeatureBannerApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to give feature banner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featureBannerRetrieve(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeatureBanner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featureBannerRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FeatureBannerApi - factory interface
 * @export
 */
export const FeatureBannerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FeatureBannerApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to give feature banner.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featureBannerRetrieve(options?: any): AxiosPromise<Array<FeatureBanner>> {
            return localVarFp.featureBannerRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FeatureBannerApi - object-oriented interface
 * @export
 * @class FeatureBannerApi
 * @extends {BaseAPI}
 */
export class FeatureBannerApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to give feature banner.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FeatureBannerApi
     */
    public featureBannerRetrieve(options?: AxiosRequestConfig) {
        return FeatureBannerApiFp(this.configuration).featureBannerRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PremiumApi - axios parameter creator
 * @export
 */
export const PremiumApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API that return Premium details based on id. PremiumRetrieveSerializer return premium, which include all SKU associated with that premium with help of SKURetrieveSerializer.
         * @param {number} id A unique integer value identifying this premium.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        premiumRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('premiumRetrieve', 'id', id)
            const localVarPath = `/api/premium/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PremiumApi - functional programming interface
 * @export
 */
export const PremiumApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PremiumApiAxiosParamCreator(configuration)
    return {
        /**
         * API that return Premium details based on id. PremiumRetrieveSerializer return premium, which include all SKU associated with that premium with help of SKURetrieveSerializer.
         * @param {number} id A unique integer value identifying this premium.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async premiumRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PremiumRetrieve>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.premiumRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PremiumApi - factory interface
 * @export
 */
export const PremiumApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PremiumApiFp(configuration)
    return {
        /**
         * API that return Premium details based on id. PremiumRetrieveSerializer return premium, which include all SKU associated with that premium with help of SKURetrieveSerializer.
         * @param {number} id A unique integer value identifying this premium.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        premiumRetrieve(id: number, options?: any): AxiosPromise<PremiumRetrieve> {
            return localVarFp.premiumRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PremiumApi - object-oriented interface
 * @export
 * @class PremiumApi
 * @extends {BaseAPI}
 */
export class PremiumApi extends BaseAPI {
    /**
     * API that return Premium details based on id. PremiumRetrieveSerializer return premium, which include all SKU associated with that premium with help of SKURetrieveSerializer.
     * @param {number} id A unique integer value identifying this premium.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PremiumApi
     */
    public premiumRetrieve(id: number, options?: AxiosRequestConfig) {
        return PremiumApiFp(this.configuration).premiumRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PremiumCategoryApi - axios parameter creator
 * @export
 */
export const PremiumCategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The List API return a list of Premium(Item) Category, - It returns all Main Category, which contain all Sub Category associated with that Main Category.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        premiumCategoryList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/premium_category/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that return Premium(Item) Category.
         * @param {number} id A unique integer value identifying this display category.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        premiumCategoryRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('premiumCategoryRetrieve', 'id', id)
            const localVarPath = `/api/premium_category/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PremiumCategoryApi - functional programming interface
 * @export
 */
export const PremiumCategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PremiumCategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * The List API return a list of Premium(Item) Category, - It returns all Main Category, which contain all Sub Category associated with that Main Category.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async premiumCategoryList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DisplayCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.premiumCategoryList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that return Premium(Item) Category.
         * @param {number} id A unique integer value identifying this display category.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async premiumCategoryRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DisplayCategory>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.premiumCategoryRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PremiumCategoryApi - factory interface
 * @export
 */
export const PremiumCategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PremiumCategoryApiFp(configuration)
    return {
        /**
         * The List API return a list of Premium(Item) Category, - It returns all Main Category, which contain all Sub Category associated with that Main Category.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        premiumCategoryList(options?: any): AxiosPromise<Array<DisplayCategory>> {
            return localVarFp.premiumCategoryList(options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that return Premium(Item) Category.
         * @param {number} id A unique integer value identifying this display category.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        premiumCategoryRetrieve(id: number, options?: any): AxiosPromise<DisplayCategory> {
            return localVarFp.premiumCategoryRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PremiumCategoryApi - object-oriented interface
 * @export
 * @class PremiumCategoryApi
 * @extends {BaseAPI}
 */
export class PremiumCategoryApi extends BaseAPI {
    /**
     * The List API return a list of Premium(Item) Category, - It returns all Main Category, which contain all Sub Category associated with that Main Category.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PremiumCategoryApi
     */
    public premiumCategoryList(options?: AxiosRequestConfig) {
        return PremiumCategoryApiFp(this.configuration).premiumCategoryList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that return Premium(Item) Category.
     * @param {number} id A unique integer value identifying this display category.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PremiumCategoryApi
     */
    public premiumCategoryRetrieve(id: number, options?: AxiosRequestConfig) {
        return PremiumCategoryApiFp(this.configuration).premiumCategoryRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RankingByCategoryApi - axios parameter creator
 * @export
 */
export const RankingByCategoryApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to get sku arranged based on ranking in different category.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rankingByCategoryRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ranking_by_category/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RankingByCategoryApi - functional programming interface
 * @export
 */
export const RankingByCategoryApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RankingByCategoryApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to get sku arranged based on ranking in different category.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rankingByCategoryRetrieve(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RankingByCategoryChild>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rankingByCategoryRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RankingByCategoryApi - factory interface
 * @export
 */
export const RankingByCategoryApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RankingByCategoryApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to get sku arranged based on ranking in different category.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rankingByCategoryRetrieve(options?: any): AxiosPromise<Array<RankingByCategoryChild>> {
            return localVarFp.rankingByCategoryRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RankingByCategoryApi - object-oriented interface
 * @export
 * @class RankingByCategoryApi
 * @extends {BaseAPI}
 */
export class RankingByCategoryApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to get sku arranged based on ranking in different category.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RankingByCategoryApi
     */
    public rankingByCategoryRetrieve(options?: AxiosRequestConfig) {
        return RankingByCategoryApiFp(this.configuration).rankingByCategoryRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RankingByPointsApi - axios parameter creator
 * @export
 */
export const RankingByPointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that allows logged in user to get premium arranged based on ranking in different point range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rankingByPointsRetrieve: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ranking_by_points/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RankingByPointsApi - functional programming interface
 * @export
 */
export const RankingByPointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RankingByPointsApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that allows logged in user to get premium arranged based on ranking in different point range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rankingByPointsRetrieve(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RankingByPointsChild>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rankingByPointsRetrieve(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RankingByPointsApi - factory interface
 * @export
 */
export const RankingByPointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RankingByPointsApiFp(configuration)
    return {
        /**
         * API endpoint that allows logged in user to get premium arranged based on ranking in different point range.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rankingByPointsRetrieve(options?: any): AxiosPromise<Array<RankingByPointsChild>> {
            return localVarFp.rankingByPointsRetrieve(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RankingByPointsApi - object-oriented interface
 * @export
 * @class RankingByPointsApi
 * @extends {BaseAPI}
 */
export class RankingByPointsApi extends BaseAPI {
    /**
     * API endpoint that allows logged in user to get premium arranged based on ranking in different point range.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RankingByPointsApi
     */
    public rankingByPointsRetrieve(options?: AxiosRequestConfig) {
        return RankingByPointsApiFp(this.configuration).rankingByPointsRetrieve(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SchemaApi - axios parameter creator
 * @export
 */
export const SchemaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format] 
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemaRetrieve: async (format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/schema/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SchemaApi - functional programming interface
 * @export
 */
export const SchemaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SchemaApiAxiosParamCreator(configuration)
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format] 
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async schemaRetrieve(format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.schemaRetrieve(format, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SchemaApi - factory interface
 * @export
 */
export const SchemaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SchemaApiFp(configuration)
    return {
        /**
         * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
         * @param {'json' | 'yaml'} [format] 
         * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        schemaRetrieve(format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options?: any): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.schemaRetrieve(format, lang, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SchemaApi - object-oriented interface
 * @export
 * @class SchemaApi
 * @extends {BaseAPI}
 */
export class SchemaApi extends BaseAPI {
    /**
     * OpenApi3 schema for this API. Format can be selected via content negotiation.  - YAML: application/vnd.oai.openapi - JSON: application/vnd.oai.openapi+json
     * @param {'json' | 'yaml'} [format] 
     * @param {'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant'} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SchemaApi
     */
    public schemaRetrieve(format?: 'json' | 'yaml', lang?: 'af' | 'ar' | 'ar-dz' | 'ast' | 'az' | 'be' | 'bg' | 'bn' | 'br' | 'bs' | 'ca' | 'cs' | 'cy' | 'da' | 'de' | 'dsb' | 'el' | 'en' | 'en-au' | 'en-gb' | 'eo' | 'es' | 'es-ar' | 'es-co' | 'es-mx' | 'es-ni' | 'es-ve' | 'et' | 'eu' | 'fa' | 'fi' | 'fr' | 'fy' | 'ga' | 'gd' | 'gl' | 'he' | 'hi' | 'hr' | 'hsb' | 'hu' | 'hy' | 'ia' | 'id' | 'ig' | 'io' | 'is' | 'it' | 'ja' | 'ka' | 'kab' | 'kk' | 'km' | 'kn' | 'ko' | 'ky' | 'lb' | 'lt' | 'lv' | 'mk' | 'ml' | 'mn' | 'mr' | 'my' | 'nb' | 'ne' | 'nl' | 'nn' | 'os' | 'pa' | 'pl' | 'pt' | 'pt-br' | 'ro' | 'ru' | 'sk' | 'sl' | 'sq' | 'sr' | 'sr-latn' | 'sv' | 'sw' | 'ta' | 'te' | 'tg' | 'th' | 'tk' | 'tr' | 'tt' | 'udm' | 'uk' | 'ur' | 'uz' | 'vi' | 'zh-hans' | 'zh-hant', options?: AxiosRequestConfig) {
        return SchemaApiFp(this.configuration).schemaRetrieve(format, lang, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SkuApi - axios parameter creator
 * @export
 */
export const SkuApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that return Item list.  This API response contain a list of Items(SKUs), - It matches criteria(like filter/sorting) given by user/FE, - Also added criteria that  if there are multiple SKU from the same premium, we only keep the lowest points required one  The List API will return a list of Item, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - filtered by `categories`, `premiums`, `max_point`, `min_point` and `status` - sorted by `popularity`(ranking), `point_low_to_high`(point ascending order) and  `point_high_to_low`(point descending order)  SKUSerializer return sku, which include premium with help of PremiumSerializer.
         * @param {string} [categories] Filter by category id
         * @param {number} [maxPoint] Filter by maximum point
         * @param {number} [minPoint] Filter by minimum point
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [premiums] Filter by premium id
         * @param {string} [sort] A field for sorting the resulte.
         * @param {'new' | 'recommended'} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuList: async (categories?: string, maxPoint?: number, minPoint?: number, page?: number, pageSize?: number, premiums?: string, sort?: string, status?: 'new' | 'recommended', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sku/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categories !== undefined) {
                localVarQueryParameter['categories'] = categories;
            }

            if (maxPoint !== undefined) {
                localVarQueryParameter['max_point'] = maxPoint;
            }

            if (minPoint !== undefined) {
                localVarQueryParameter['min_point'] = minPoint;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (premiums !== undefined) {
                localVarQueryParameter['premiums'] = premiums;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that return Item list for search parameter.  This API response contain a list of Items(SKUs), - It matches criteria(like filter/sorting/search) given by user/FE, - Also added criteria that  if there are multiple SKU from the same premium, we only keep the lowest points required one  The List API will return a list of Item, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - filtered by `categories`, `premiums`, `max_point`, `min_point` and `status` - sorted by `popularity`(ranking), `point`(ascending order) and `point`(descending order) - searched by item_name, category_name, catch, text, content, note, menu_no via the `search` parameter.  SKUSerializer return sku, which include premium with help of PremiumSerializer.
         * @param {string} [categories] Filter by category id
         * @param {number} [maxPoint] Filter by maximum point
         * @param {number} [minPoint] Filter by minimum point
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [premiums] Filter by premium id
         * @param {string} [search] A search term.
         * @param {string} [sort] A field for sorting the resulte.
         * @param {'new' | 'recommended'} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuListSearchRetrieve: async (categories?: string, maxPoint?: number, minPoint?: number, page?: number, pageSize?: number, premiums?: string, search?: string, sort?: string, status?: 'new' | 'recommended', options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sku/list_search/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categories !== undefined) {
                localVarQueryParameter['categories'] = categories;
            }

            if (maxPoint !== undefined) {
                localVarQueryParameter['max_point'] = maxPoint;
            }

            if (minPoint !== undefined) {
                localVarQueryParameter['min_point'] = minPoint;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (premiums !== undefined) {
                localVarQueryParameter['premiums'] = premiums;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API that update quantity of sku based on id.
         * @param {Array<PatchedSKURedeemChildRequest>} patchedSKURedeemChildRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuRedeemPartialUpdate: async (patchedSKURedeemChildRequest: Array<PatchedSKURedeemChildRequest>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'patchedSKURedeemChildRequest' is not null or undefined
            assertParamExists('skuRedeemPartialUpdate', 'patchedSKURedeemChildRequest', patchedSKURedeemChildRequest)
            const localVarPath = `/api/sku/redeem/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(patchedSKURedeemChildRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API endpoint that return SKU.
         * @param {number} id A unique integer value identifying this sku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuRetrieve: async (id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('skuRetrieve', 'id', id)
            const localVarPath = `/api/sku/{id}/`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SkuApi - functional programming interface
 * @export
 */
export const SkuApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SkuApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that return Item list.  This API response contain a list of Items(SKUs), - It matches criteria(like filter/sorting) given by user/FE, - Also added criteria that  if there are multiple SKU from the same premium, we only keep the lowest points required one  The List API will return a list of Item, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - filtered by `categories`, `premiums`, `max_point`, `min_point` and `status` - sorted by `popularity`(ranking), `point_low_to_high`(point ascending order) and  `point_high_to_low`(point descending order)  SKUSerializer return sku, which include premium with help of PremiumSerializer.
         * @param {string} [categories] Filter by category id
         * @param {number} [maxPoint] Filter by maximum point
         * @param {number} [minPoint] Filter by minimum point
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [premiums] Filter by premium id
         * @param {string} [sort] A field for sorting the resulte.
         * @param {'new' | 'recommended'} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skuList(categories?: string, maxPoint?: number, minPoint?: number, page?: number, pageSize?: number, premiums?: string, sort?: string, status?: 'new' | 'recommended', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSKUList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skuList(categories, maxPoint, minPoint, page, pageSize, premiums, sort, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that return Item list for search parameter.  This API response contain a list of Items(SKUs), - It matches criteria(like filter/sorting/search) given by user/FE, - Also added criteria that  if there are multiple SKU from the same premium, we only keep the lowest points required one  The List API will return a list of Item, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - filtered by `categories`, `premiums`, `max_point`, `min_point` and `status` - sorted by `popularity`(ranking), `point`(ascending order) and `point`(descending order) - searched by item_name, category_name, catch, text, content, note, menu_no via the `search` parameter.  SKUSerializer return sku, which include premium with help of PremiumSerializer.
         * @param {string} [categories] Filter by category id
         * @param {number} [maxPoint] Filter by maximum point
         * @param {number} [minPoint] Filter by minimum point
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [premiums] Filter by premium id
         * @param {string} [search] A search term.
         * @param {string} [sort] A field for sorting the resulte.
         * @param {'new' | 'recommended'} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skuListSearchRetrieve(categories?: string, maxPoint?: number, minPoint?: number, page?: number, pageSize?: number, premiums?: string, search?: string, sort?: string, status?: 'new' | 'recommended', options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedSKUList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skuListSearchRetrieve(categories, maxPoint, minPoint, page, pageSize, premiums, search, sort, status, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API that update quantity of sku based on id.
         * @param {Array<PatchedSKURedeemChildRequest>} patchedSKURedeemChildRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skuRedeemPartialUpdate(patchedSKURedeemChildRequest: Array<PatchedSKURedeemChildRequest>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skuRedeemPartialUpdate(patchedSKURedeemChildRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * API endpoint that return SKU.
         * @param {number} id A unique integer value identifying this sku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skuRetrieve(id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SKU>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skuRetrieve(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SkuApi - factory interface
 * @export
 */
export const SkuApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SkuApiFp(configuration)
    return {
        /**
         * API endpoint that return Item list.  This API response contain a list of Items(SKUs), - It matches criteria(like filter/sorting) given by user/FE, - Also added criteria that  if there are multiple SKU from the same premium, we only keep the lowest points required one  The List API will return a list of Item, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - filtered by `categories`, `premiums`, `max_point`, `min_point` and `status` - sorted by `popularity`(ranking), `point_low_to_high`(point ascending order) and  `point_high_to_low`(point descending order)  SKUSerializer return sku, which include premium with help of PremiumSerializer.
         * @param {string} [categories] Filter by category id
         * @param {number} [maxPoint] Filter by maximum point
         * @param {number} [minPoint] Filter by minimum point
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [premiums] Filter by premium id
         * @param {string} [sort] A field for sorting the resulte.
         * @param {'new' | 'recommended'} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuList(categories?: string, maxPoint?: number, minPoint?: number, page?: number, pageSize?: number, premiums?: string, sort?: string, status?: 'new' | 'recommended', options?: any): AxiosPromise<PaginatedSKUList> {
            return localVarFp.skuList(categories, maxPoint, minPoint, page, pageSize, premiums, sort, status, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that return Item list for search parameter.  This API response contain a list of Items(SKUs), - It matches criteria(like filter/sorting/search) given by user/FE, - Also added criteria that  if there are multiple SKU from the same premium, we only keep the lowest points required one  The List API will return a list of Item, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - filtered by `categories`, `premiums`, `max_point`, `min_point` and `status` - sorted by `popularity`(ranking), `point`(ascending order) and `point`(descending order) - searched by item_name, category_name, catch, text, content, note, menu_no via the `search` parameter.  SKUSerializer return sku, which include premium with help of PremiumSerializer.
         * @param {string} [categories] Filter by category id
         * @param {number} [maxPoint] Filter by maximum point
         * @param {number} [minPoint] Filter by minimum point
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {string} [premiums] Filter by premium id
         * @param {string} [search] A search term.
         * @param {string} [sort] A field for sorting the resulte.
         * @param {'new' | 'recommended'} [status] Filter by status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuListSearchRetrieve(categories?: string, maxPoint?: number, minPoint?: number, page?: number, pageSize?: number, premiums?: string, search?: string, sort?: string, status?: 'new' | 'recommended', options?: any): AxiosPromise<PaginatedSKUList> {
            return localVarFp.skuListSearchRetrieve(categories, maxPoint, minPoint, page, pageSize, premiums, search, sort, status, options).then((request) => request(axios, basePath));
        },
        /**
         * API that update quantity of sku based on id.
         * @param {Array<PatchedSKURedeemChildRequest>} patchedSKURedeemChildRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuRedeemPartialUpdate(patchedSKURedeemChildRequest: Array<PatchedSKURedeemChildRequest>, options?: any): AxiosPromise<string> {
            return localVarFp.skuRedeemPartialUpdate(patchedSKURedeemChildRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * API endpoint that return SKU.
         * @param {number} id A unique integer value identifying this sku.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skuRetrieve(id: number, options?: any): AxiosPromise<SKU> {
            return localVarFp.skuRetrieve(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SkuApi - object-oriented interface
 * @export
 * @class SkuApi
 * @extends {BaseAPI}
 */
export class SkuApi extends BaseAPI {
    /**
     * API endpoint that return Item list.  This API response contain a list of Items(SKUs), - It matches criteria(like filter/sorting) given by user/FE, - Also added criteria that  if there are multiple SKU from the same premium, we only keep the lowest points required one  The List API will return a list of Item, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - filtered by `categories`, `premiums`, `max_point`, `min_point` and `status` - sorted by `popularity`(ranking), `point_low_to_high`(point ascending order) and  `point_high_to_low`(point descending order)  SKUSerializer return sku, which include premium with help of PremiumSerializer.
     * @param {string} [categories] Filter by category id
     * @param {number} [maxPoint] Filter by maximum point
     * @param {number} [minPoint] Filter by minimum point
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [premiums] Filter by premium id
     * @param {string} [sort] A field for sorting the resulte.
     * @param {'new' | 'recommended'} [status] Filter by status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkuApi
     */
    public skuList(categories?: string, maxPoint?: number, minPoint?: number, page?: number, pageSize?: number, premiums?: string, sort?: string, status?: 'new' | 'recommended', options?: AxiosRequestConfig) {
        return SkuApiFp(this.configuration).skuList(categories, maxPoint, minPoint, page, pageSize, premiums, sort, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that return Item list for search parameter.  This API response contain a list of Items(SKUs), - It matches criteria(like filter/sorting/search) given by user/FE, - Also added criteria that  if there are multiple SKU from the same premium, we only keep the lowest points required one  The List API will return a list of Item, with pagination support (see `page` and `page_size` parameters)  The List API can also be: - filtered by `categories`, `premiums`, `max_point`, `min_point` and `status` - sorted by `popularity`(ranking), `point`(ascending order) and `point`(descending order) - searched by item_name, category_name, catch, text, content, note, menu_no via the `search` parameter.  SKUSerializer return sku, which include premium with help of PremiumSerializer.
     * @param {string} [categories] Filter by category id
     * @param {number} [maxPoint] Filter by maximum point
     * @param {number} [minPoint] Filter by minimum point
     * @param {number} [page] A page number within the paginated result set.
     * @param {number} [pageSize] Number of results to return per page.
     * @param {string} [premiums] Filter by premium id
     * @param {string} [search] A search term.
     * @param {string} [sort] A field for sorting the resulte.
     * @param {'new' | 'recommended'} [status] Filter by status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkuApi
     */
    public skuListSearchRetrieve(categories?: string, maxPoint?: number, minPoint?: number, page?: number, pageSize?: number, premiums?: string, search?: string, sort?: string, status?: 'new' | 'recommended', options?: AxiosRequestConfig) {
        return SkuApiFp(this.configuration).skuListSearchRetrieve(categories, maxPoint, minPoint, page, pageSize, premiums, search, sort, status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API that update quantity of sku based on id.
     * @param {Array<PatchedSKURedeemChildRequest>} patchedSKURedeemChildRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkuApi
     */
    public skuRedeemPartialUpdate(patchedSKURedeemChildRequest: Array<PatchedSKURedeemChildRequest>, options?: AxiosRequestConfig) {
        return SkuApiFp(this.configuration).skuRedeemPartialUpdate(patchedSKURedeemChildRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API endpoint that return SKU.
     * @param {number} id A unique integer value identifying this sku.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SkuApi
     */
    public skuRetrieve(id: number, options?: AxiosRequestConfig) {
        return SkuApiFp(this.configuration).skuRetrieve(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TaskProgressApi - axios parameter creator
 * @export
 */
export const TaskProgressApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * API endpoint that returns whether an Async job is finished, and what to do with the job.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskProgressRetrieve: async (taskId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'taskId' is not null or undefined
            assertParamExists('taskProgressRetrieve', 'taskId', taskId)
            const localVarPath = `/api/task_progress/{task_id}`
                .replace(`{${"task_id"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "Validation-key", configuration)

            // authentication jwtAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskProgressApi - functional programming interface
 * @export
 */
export const TaskProgressApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskProgressApiAxiosParamCreator(configuration)
    return {
        /**
         * API endpoint that returns whether an Async job is finished, and what to do with the job.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskProgressRetrieve(taskId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskProgressRetrieve(taskId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TaskProgressApi - factory interface
 * @export
 */
export const TaskProgressApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskProgressApiFp(configuration)
    return {
        /**
         * API endpoint that returns whether an Async job is finished, and what to do with the job.
         * @param {string} taskId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskProgressRetrieve(taskId: string, options?: any): AxiosPromise<void> {
            return localVarFp.taskProgressRetrieve(taskId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TaskProgressApi - object-oriented interface
 * @export
 * @class TaskProgressApi
 * @extends {BaseAPI}
 */
export class TaskProgressApi extends BaseAPI {
    /**
     * API endpoint that returns whether an Async job is finished, and what to do with the job.
     * @param {string} taskId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TaskProgressApi
     */
    public taskProgressRetrieve(taskId: string, options?: AxiosRequestConfig) {
        return TaskProgressApiFp(this.configuration).taskProgressRetrieve(taskId, options).then((request) => request(this.axios, this.basePath));
    }
}


